import React, { useEffect, useState } from 'react';
import { atom, swr, useAtomCallback, useAtomValue } from '@exodus/headless-ui';
import useTrackAssetConfigureEvent from '../../hooks/use-track-configure-asset.js';
import { prefillIdAtom, prefillsAtom, swapModeAtom, isLoadingAtom, toAssetAtom, fromAssetAtom, } from '../../../atoms/index.js';
import { usePrevious } from '@exodus/react-hooks';
const prefillsSWRAtom = swr(prefillsAtom);
const DEFAULT_OPTIONS = [
    { id: 'min', label: 'MIN' },
    { id: 'half', label: 'HALF' },
    { id: 'max', label: 'MAX' },
];
const pairIdAtom = atom((get) => {
    const fromAsset = get(fromAssetAtom);
    const toAsset = get(toAssetAtom);
    return `${fromAsset.ticker}_${toAsset.ticker}`;
});
const PercentageSwitch = ({ Component, className, style, onPress, }) => {
    const prefillId = useAtomValue(prefillIdAtom);
    const prefills = useAtomValue(prefillsSWRAtom);
    const isLoading = useAtomValue(isLoadingAtom);
    const trackAssetConfigureSwap = useTrackAssetConfigureEvent();
    const pairId = useAtomValue(pairIdAtom);
    const prevPairId = usePrevious(pairId);
    const [prefillOptions, setPrefillOptions] = useState(DEFAULT_OPTIONS);
    useEffect(() => {
        if (prevPairId !== pairId) {
            setPrefillOptions(DEFAULT_OPTIONS);
            return;
        }
        if (prefills.data && !prefills.validating) {
            setPrefillOptions(Object.entries(prefills.data).map(([id, { label }]) => ({ id, label })));
        }
        if (prefills.error) {
            setPrefillOptions(DEFAULT_OPTIONS);
        }
    }, [prefills, pairId, prevPairId]);
    const handlePress = useAtomCallback((get, set, id) => {
        void trackAssetConfigureSwap();
        set(swapModeAtom, 'ExactIn');
        set(prefillIdAtom, id);
        onPress?.(id);
    }, [onPress, trackAssetConfigureSwap]);
    if (Component) {
        return (React.createElement(Component, { onChange: handlePress, value: prefillId, loading: isLoading, options: prefillOptions, className: className, style: style }));
    }
    return null;
};
export default PercentageSwitch;
